import { parseError } from '../libs/parser';
import { useContext, useEffect, useState } from 'react';
import Context from '../provider';
import memberApi from '../libs/api/memberApi';

/**
 * Custom Hook to detect if an element is scrolling
 * @returns {number} Whether the element is currently scrolling
 */
function useNotificationCount() {
  const { init, dispatch } = useContext(Context);

  const [count, setCount] = useState(0);

  const fetchUnreadNotificationsCount = async () => {
    try {
      const response = await memberApi.getUnreadNotifications();

      dispatch({ type: 'SWITCH_UNREAD_TARGET', payload: response.count > 0 });

      setCount(response.count);

    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    }
  };

  useEffect(() => {
    if (init) {
      fetchUnreadNotificationsCount();
    }
  }, [init]);

  return count;
}

export default useNotificationCount;